<template>
    <b-container fluid>
        <b-row>
            <b-col md="6">
                <b-form-group
                    id="fieldset-customer"
                    label="Customer"
                    label-for="input-customer"
                >
                    <customer-type-ahead
                        v-model="model.customer_id"
                    ></customer-type-ahead>
                </b-form-group>
            </b-col>
            <b-col md="6">
                <b-form-group
                    id="fieldset-orderType"
                    label="Order Type"
                    label-for="input-orderType"
                >
                    <b-form-select
                        id="input-orderType"
                        v-model="model.type"
                        value-field="id"
                        text-field="name"
                        :options="orderTypes"
                    ></b-form-select>
                </b-form-group>
            </b-col>
        </b-row>
        <b-row>
            <b-col>
                <b-form-group
                    id="fieldset-officer"
                    label="Officer"
                    label-for="input-officer"
                >
                    <b-form-select
                        id="input-officer"
                        v-model="model.driver_id"
                        value-field="id"
                        text-field="name"
                        :options="drivers"
                    ></b-form-select>
                </b-form-group>
            </b-col>
        </b-row>

        <b-row>
            <b-col md="6">
                <b-form-group
                    id="fieldset-created_start"
                    label="Start Date"
                    label-for="input-created_start"
                >
                    <b-form-input
                        type="date"
                        id="input-created_start"
                        v-model="model.created_start"
                    ></b-form-input>
                </b-form-group>
            </b-col>
            <b-col md="6">
                <b-form-group
                    id="fieldset-created_end"
                    label="End Date"
                    label-for="input-created_end"
                >
                    <b-form-input
                        type="date"
                        id="input-created_end"
                        v-model="model.created_end"
                    ></b-form-input>
                </b-form-group>
            </b-col>
        </b-row>

        <b-row>
            <b-col md="6">
                <b-form-group label="Completed" v-slot="{ ariaDescribedby }">
                    <b-form-radio-group
                        id="radio-group-completed"
                        v-model="model.completed"
                        :aria-describedby="ariaDescribedby"
                        name="radio-completed"
                    >
                        <b-form-radio value="any">Any</b-form-radio>
                        <b-form-radio value="yes">Yes</b-form-radio>
                        <b-form-radio value="no">No</b-form-radio>
                    </b-form-radio-group>
                </b-form-group>
            </b-col>
            <b-col md="6">
                <b-form-group label="Updates" v-slot="{ ariaDescribedby }">
                    <b-form-radio-group
                        id="radio-group-updated"
                        v-model="model.is_updated"
                        :aria-describedby="ariaDescribedby"
                        name="radio-updated"
                    >
                        <b-form-radio value="any">All</b-form-radio>
                        <b-form-radio value="changed">Changed</b-form-radio>
                        <b-form-radio value="notChanged"
                            >Not Changed</b-form-radio
                        >
                    </b-form-radio-group>
                </b-form-group>
            </b-col>
        </b-row>
    </b-container>
</template>

<script>
import CustomerTypeAhead from '@/components/CustomerTypeAhead.vue'
import moment from 'moment'

const dateRangeEnum = {
    today: 0,
    yesterday: 1,
    custom: 2,
}
export default {
    components: { CustomerTypeAhead },
    name: 'reports-table',
    data() {
        return {
            model: {
                // Why called it "changed"
                // and not the "updated_at" column used like in
                // the database ?
                changed: 0,
                driver_id: 0,
                customer_id: 0,
                warehouse_id: 0,
                completed: 'any',
                type: 0,
                is_updated: 'any',
                created_start: moment().startOf('month').format('YYYY-MM-DD'),
                created_end: moment().endOf('month').format('YYYY-MM-DD'),
            },
        }
    },
    props: ['dateRange', 'orderTypes'],
    computed: {
        drivers() {
            return [{ name: 'Any', id: 0 }].concat(
                (this.$store.state.orders.drivers || []).map(x => ({
                    name: `${x.first_name} ${x.last_name}`,
                    id: x.id,
                }))
            )
        },
    },
    mounted() {
        this.$store.dispatch('orders/fetchDrivers')
        this.$store.dispatch('orders/fetchWarehouses')

        //init remote filters
    },

    watch: {
        'model.created_start': function () {
            this.updateModel()
        },
        'model.created_end': function () {
            this.updateModel()
        },
        'model.is_updated': function () {
            this.updateModel()
        },
        'model.completed': function () {
            this.updateModel()
        },
        'model.driver_id': function () {
            this.updateModel()
        },
        'model.customer_id': function () {
            this.updateModel()
        },
        'model.type': function () {
            this.updateModel()
        },
        dateRange: function (val) {
            switch (val) {
                case dateRangeEnum.today:
                    this.model.created_start = moment().format('YYYY-MM-DD')
                    this.model.created_end = moment().format('YYYY-MM-DD')
                    break
                //created_end: moment().endOf('month').format('YYYY-MM-DD'),
                case dateRangeEnum.yesterday:
                    this.model.created_start = moment()
                        .subtract(1, 'days')
                        .format('YYYY-MM-DD')
                    this.model.created_end = moment()
                        .subtract(1, 'days')
                        .format('YYYY-MM-DD')
                    break
                default:
                    break
            }
        },
    },
    methods: {
        updateModel() {
            const $this = this
            $this.$nextTick(() => {
                this.$emit('input', { ...$this.model })
            })
        },
    },
}
</script>
